import { useContext } from 'react';
import { styled, Typography } from '@mui/material';
import { KrDetail } from '@workboard/ui-okr';
import { OrgConfigContext } from '../../context/OrgConfigContextProvider';
import { useTranslation } from 'react-i18next';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 0px;
`;

const flatKrs = (arr) =>
  arr.reduce((acc, val) => {
    acc.push(val);
    if (val?.nestedKrs) {
      const nestedKrs = flatKrs(val.nestedKrs);
      nestedKrs.forEach((nestedKr) => {
        nestedKr.isNested = true;
      });
      acc.push(...nestedKrs);
    }
    return acc;
  }, []);

export const KeyResultCardList = (props) => { 
  const { isSemEnabled } = useContext(OrgConfigContext);
  const { t } = useTranslation();
  const [error, data] = props.data;
  if (error) {
    return <Typography variant="subtitle1">{t('Error: Loading KR')}</Typography>;
  }

  if(!data?.length) {
    return <Typography variant="subtitle1">{t('No Key Results')}</Typography>;
  }

  return (
    <Container>
      {flatKrs(data).map((kr, idx) => (
        <KrDetail
          context={{
            location: 'CONVERSATION_MEETING_PAGE',
            locationDetail: 'Meeting_Conversation_Key_Results',
            semEnabled: isSemEnabled,
          }}
          key={`${kr?.id}-${idx}`}
          kr={kr}
          data-krid={kr?.id}
          isNestedKr={kr?.isNested}
        />
      ))}
    </Container>
  );
};
